module.exports = __webpack_public_path__ + "img/to-be-whole.c2fd7684.png";